import Utils from '@/common/utils/utils';
import OverFlowTooltipWithTabsMui from "../../../common/OverFlowTooltipWithTabsMui";
import Bookmark from "./Bookmark";
import './Bookmark.css';
import TaggedBookmarkListName from './TaggedBookmarkListName';
import UserTagPrivateBookmarkCount from './UserTagPrivateBookmarkCount';

function TicketBookmark({
    isViewDelete = false,
    ticketKnowledge,
    setIsOpenModalReloadPage,
    panelType
}) {

    return (
        <div className='ticket-knowledge-bookmark'>
            <div style={{ paddingRight: 6 }}>
                <Bookmark
                    isViewDelete={isViewDelete}
                    ticketKnowledge={ticketKnowledge}
                    panelType={panelType}
                    isShowEdit={false}
                    isShowDefaultBookmark={true}
                    tagDefaultBookmarkClassName={'reset-position-list-bookmark-icon'}
                />
            </div>
            <Bookmark
                isViewDelete={isViewDelete}
                ticketKnowledge={ticketKnowledge}
                panelType={panelType}
                isShowEdit={true}
                bookmarkPopupContainerClassName={'reset-position-bookmark-popup-container'}
            />

            <div className='ticket-knowledge-bm-tagged-list-text-wrap'>
                <TaggedBookmarkListName bookmarkListText={ticketKnowledge?.bookmarkListText} className="ticket-knowledge-bm-tagged-list-text" />
                <UserTagPrivateBookmarkCount ticketKnowledge={ticketKnowledge}/>
            </div>
        </div>
    );
}

export default TicketBookmark;